
<script>
import NewForm from './New'
export default {
  mixins: [NewForm],
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.$http.get(`/exchange-rates/${this.$route.query.id}`).then(res => {
        this.form = res.data
      })
    },
    save() {
      this.$http
        .put(`/exchange-rates/${this.$route.query.id}`, this.form)
        .then(() => {
          this.$router.go(-1)
        })
        .catch(err => this.$catch(err))
    },
    remove() {
      this.$http.delete(`/exchange-rates/${this.$route.query.id}`).then(() => {
        this.$router.go(-1)
      })
    }
  }
}
</script>
